import { createEvent } from 'effector';

export type AlertType = 'info' | 'success' | 'error' | 'warning' | null;

export type ShowAlertPayload = {
  label: string | JSX.Element;
  type?: AlertType;
  duration?: number;
  css?: string | null;
  onClick?: () => void;
};

export type ShowBottomAlertPayload = {
  label?: string | JSX.Element;
  type?: AlertType;
  customAlert?: JSX.Element | null;
  position?: number | null;
};

/**
 * @deprecated Use `toaster.create` from `@m/components/ui/toaster` instead.
 */
export const showAlert = createEvent<ShowAlertPayload>();

/**
 * @deprecated Use `toaster.dismiss` from `@m/components/ui/toaster` instead.
 */
export const hideAlert = createEvent<void>();

/**
 * @deprecated Use `toaster.create` from `@m/components/ui/toaster` instead.
 */
export const showBottomAlert = createEvent<ShowBottomAlertPayload>();

/**
 * @deprecated Use `toaster.dismiss` from `@m/components/ui/toaster` instead.
 */
export const hideBottomAlert = createEvent<void>();
